// extracted by mini-css-extract-plugin
module.exports = {"postItem":"PostItem_postItem__FHF4y","image":"PostItem_image__p8mhp","overlay":"PostItem_overlay__Rek4F","fallbackImage":"PostItem_fallbackImage__R9uVf"};